<div [ngClass]="{'logged-in': render_sidebar}"
     class="navigation-container">
	<div class="header-holder" #header_holder></div>
	<menu-header #header_element
	             [mainStructure]="splitStructure.main"
	             [headerStructure]="splitStructure.header"></menu-header>
	<menu-sidebar *ngIf="render_sidebar" [menuStructure]="splitStructure"></menu-sidebar>
</div>
